// removed by extract-text-webpack-plugin
module.exports = {"modalSearch":"searchForm_modalSearch_2mQqf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/company/overviewModal/searchForm.scss
// module id = 1561
// module chunks = 0